import CacheEntry from "./CacheEntry";

export default class StorageService {
  constructor(config) {
    this.cachePrefix = "pushDelivery.cache.";
    this.dbConfig = config.app.database;
    this.localStorageConfiguration = config.app.localStorage;
  }

  storeItemLocalStorage(name, element) {
    localStorage.setItem(name, JSON.stringify(element));
  }

  getItemLocalStorage(name) {
    return JSON.parse(localStorage.getItem(name));
  }

  removeItemLocalStorage(name) {
    localStorage.removeItem(name);
  }

  init() {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        return reject("Your browser doesn't IndexedDB.");
      }

      const dbRequest = indexedDB.open(this.dbConfig.notificationDB, this.dbConfig.version);
      const databaseConfig = this.dbConfig;
      const storageService = this;
      dbRequest.onupgradeneeded = function (event) {
        storageService.db = event.target.result;
        if (event.oldVersion < 1) {
          const objectStore = storageService.db.createObjectStore(databaseConfig.notificationTable, {
            autoIncrement: true,
          });
          objectStore.createIndex("date", "date", { unique: false });
          const heartbeatStore = storageService.db.createObjectStore(databaseConfig.resubTable, { keyPath: "deviceId" });
          heartbeatStore.createIndex("deviceId", "deviceId", { unique: true });
        }
      };
      dbRequest.onsuccess = function (event) {
        storageService.db = event.target.result;
        resolve();
      };
      dbRequest.onerror = function (event) {
        console.log("error opening database:", event.target.errorCode);
        reject();
        throw new Error("Unable to open database");
      };
      this.migrateLegacyDeviceInformation();
    });
  }

  migrateLegacyDeviceInformation() {
    if (window.localStorage.getItem(this.localStorageConfiguration.deviceStorageKey) === null) {
      if (typeof this.localStorageConfiguration.migration === "function") {
        this.localStorageConfiguration.migration(this.localStorageConfiguration);
      }
    }
  }

  save(payload) {
    let tx = this.db.transaction([this.dbConfig.notificationTable], "readwrite");
    let store = tx.objectStore(this.dbConfig.notificationTable);

    tx.onerror = function (event) {
      console.log("error storing notification:", event.target.error);
    };
    store.add(payload);
  }

  heartBeat(beat) {
    let tx = this.db.transaction([this.dbConfig.resubTable], "readwrite");
    let store = tx.objectStore(this.dbConfig.resubTable);

    tx.onerror = function (event) {
      console.log("error storing heartbeat:", event.target.error);
    };
    store.put(beat);
  }

  getAllEntries() {
    let tx = this.db.transaction([this.dbConfig.notificationTable], "readonly");
    let store = tx.objectStore(this.dbConfig.notificationTable);
    const index = store.index("date");
    const storageService = this;
    return new Promise((resolve, reject) => {
      const maxResults = storageService.dbConfig.notificationMaxResults;
      const allNotifications = [];

      const cursor = index.openCursor(null, "prev");
      cursor.onsuccess = function (event) {
        const currentCursor = event.target.result;
        if (currentCursor && allNotifications.length <= maxResults) {
          allNotifications.push(currentCursor.value);
          currentCursor.continue();
        } else {
          resolve(allNotifications);
        }
      };
      cursor.onerror = reject;
    });
  }

  addCache(key, item, ttl) {
    sessionStorage.setItem(this.cachePrefix + key, JSON.stringify(new CacheEntry(item, ttl)));
  }

  getCache(key) {
    let value = sessionStorage.getItem(this.cachePrefix + key);
    if (value) {
      let cacheEntry = JSON.parse(value);
      if (cacheEntry.expire > new Date().getTime()) {
        return cacheEntry.item;
      }
    }
    return null;
  }

  removeCache(key) {
    sessionStorage.removeItem(this.cachePrefix + key);
  }
}
